// noinspection ES6UnusedImports

import {loader} from './utils/loaders'; //eslint-disable-line @typescript-eslint/no-unused-vars
import { h } from '@stencil/core'; //eslint-disable-line @typescript-eslint/no-unused-vars
import Container from 'typedi';
import type {UiaasSearchStrategies} from './uiaas-search-strategies';
import {fallbackStrategiesData} from './fallbackStrategiesData';
import type {StrategyBuilder} from './StrategyBuilder';
import {STRATEGY_SERVICE} from './utils/variables';
import {makeLogger} from '../../logger/logger';
import {closestParentElement} from '../../utils/helpers/get-closest-parent';

const {info, warn} = makeLogger({pathToCurrentFile: 'components/strategies/Strategies.tsx'});

export class StrategiesFactory {

  static createStrategy(element:HTMLElement): Strategies {
      const closestStrategyComponent = closestParentElement('uiaas-search-strategies', element);
      if (closestStrategyComponent) {

        return new Strategies(closestStrategyComponent as unknown as UiaasSearchStrategies );
      }
      else {
        info('UIAAS strategy component was not found, fallback strategies were applied, ');
        return new Strategies();
      }
  }
}

export class Strategies {
  strategyData;

  constructor(strategyComponent?: UiaasSearchStrategies) {
      this.strategyData = strategyComponent?.composedStrategy || fallbackStrategiesData;
  }

  for<
    StrategyType,
    SpecificStrategyBuilder extends StrategyBuilder<StrategyType> = StrategyBuilder<StrategyType>
  >(name: string): StrategyType {

      const details = this.strategyData[name];
      //Checking for custom function added externally to UIAAS
      if (this.strategyData[name]?.customStrategy) {
        return new this.strategyData[name].customStrategy(details);
      }
      try {
        const builder = Container.get<SpecificStrategyBuilder>(details.strategyType + STRATEGY_SERVICE);

        return builder.build(details);

      } catch {
        warn(`Strategy ${name + STRATEGY_SERVICE} was not found. Fallback strategy for ${name} was applied`);
        return Container.get<SpecificStrategyBuilder>(fallbackStrategiesData[name].strategyType + STRATEGY_SERVICE).build(fallbackStrategiesData[name]);
      }
  }
}
